import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SoundSwitcher from './SoundSwitcher';

const Player = () => {
  const { currentUser } = useAuth();

  if (!currentUser) return null;

  return (
    <div className="mx-auto w-100" style={{ maxWidth: '100%' }}>
      <SoundSwitcher />
    </div>
  );
};

export default Player;

